module.exports = __webpack_public_path__ + "3c21cdf388cf39535146dbed1048b1a8.png";